export function setDocument(title,keywords,description){
  document.title = title +' | BUKI LEATHER LIMITED'
  const  _headEl = document.getElementsByTagName('head')[0]

  const _headKwEl = _headEl.querySelector('meta[name="keywords"]') || document.createElement('meta')
  _headKwEl.setAttribute("name","keywords")
  _headKwEl.setAttribute("content",keywords)
  _headEl.appendChild(_headKwEl)

  const _headDcEl = _headEl.querySelector('meta[name="description"]') || document.createElement('meta')
  _headDcEl.setAttribute("name","description")
  _headDcEl.setAttribute("content",description)
  _headEl.appendChild(_headDcEl)
}
